// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__286Vz","left":"navbar_left__2PE44","right":"navbar_right__3KiEV","icon":"navbar_icon__2WGoR","name":"navbar_name__2tNIg","link":"navbar_link__1K4zd"};